import React, {useState, useEffect, useCallback} from 'react';


import {MapContainer, Marker, TileLayer, Popup} from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import MapMarker from "../../../assets/images/mapMarker.png";
import {TbCheck} from "react-icons/tb";

import {toast} from "react-toastify";
import { useParams} from "react-router-dom";
import {getAddress, storeAddress, updateAddress} from "../api/AddressAPI";
import {showError, showSuccess} from "../../../utils/toastHelper";

let DefaultIcon = L.icon({
    iconUrl: MapMarker,
    iconSize: [20, 20],
});

L.Marker.prototype.options.icon = DefaultIcon;

const center = [36.32, 59.51]
const zoom = 13

function AddAddress(props) {
    const {id} = useParams();
    const [haveLocation, setHaveLocation] = React.useState(false);
    const [map, setMap] = React.useState(null);
    const [address, setAddress] = React.useState('');
    const [title, setTitle] = React.useState('');
    const [phone, setPhone] = React.useState('');
    const [position, setPosition] = useState(map ? map.getCenter() : {lat: 36.3136, lng: 59.5899})
    const [, setIsLoaded] = React.useState(false);


    const onSetLocation = () => {
        setHaveLocation(true);

    }

    const onSaveAddress = async () => {
        try {

            setHaveLocation(false)
            const request = {
                title,
                address,
                contact_phone: phone,
                lat : position.lat.toFixed(4),
                long : position.lng.toFixed(4),


            }
            const result = await updateAddress(id,request);

            showSuccess(result.message );
            setTimeout (() => {
                window.history.back()
            },1500)


        } catch (error) {
            console.log(error)

            if (error.response) {
                showError(error.response.data.message || "امکان ثبت آدرس  وجود ندارد");
            } else {
                showError("خطا در ارتباط با سرور.");
            }
        }



    }

    const onMove = useCallback(() => {
        setPosition(map.getCenter())
    }, [map])

    useEffect(async () => {


        if (map) {
            // handleLocationClick()
            map.on('move', onMove)
            const response = await getAddress(id);
            setAddress(response.data.address.address);
            setTitle(response.data.address.title)
            setPhone(response.data.address.contact_phone)
            setPosition({lat: parseInt(response.data.address.lat), lng: parseInt(response.data.address.long)})

            map.panTo(new L.LatLng(parseInt(response.data.address.lat), parseInt(response.data.address.long)));

        }

        return () => {
            if (map)
                map.off('move', onMove)
        }
    }, [map, onMove , id])


    return (
        <React.Fragment>
            {
                haveLocation &&
                <section className="container modal-bg max-w-lg">
                    <div className="row rtl overflow-scroll vh-100">

                        <div className="col-12 form-floating mt-3">
                                                <textarea className="form-control"
                                                          placeholder="توضیحات"
                                                          id="floatingTextarea"
                                                          rows={8}
                                                          value={address}
                                                          onChange={(val) => {
                                                              setAddress(val.target.value)
                                                          }}
                                                >
                            </textarea>
                            <label htmlFor="floatingTextarea" className='text-small-2 right-0'>
                                آدرس دقیق
                            </label>
                        </div>
                        <div className="col-12 mt-3">
                            <div className="form-floating mb-3">
                                <input type="text"
                                       className="form-control"
                                       id="floatingInput"
                                       placeholder="عنوان"
                                       value={title}
                                       onChange={(val) => {
                                           setTitle(val.target.value)
                                       }}
                                />
                                <label htmlFor="floatingInput" className='text-small-2 right-0'>عنوان آدرس </label>
                            </div>
                        </div>
                        <div className="col-12 mt-3">
                            <div className="form-floating mb-3">
                                <input type="tel"
                                       className="form-control"
                                       id="floatingInput"
                                       placeholder="تماس"
                                       value={phone}
                                       onChange={(val) => {
                                           setPhone(val.target.value)
                                       }}
                                />
                                <label htmlFor="floatingInput" className='text-small-2 right-0'>شماره تماس </label>
                            </div>
                        </div>
                        <div className="col-8 mt-3">
                            <button className='w-100 btn btn-primary text-small-2'
                                    onClick={onSaveAddress}
                            >
                                ثبت آدرس
                            </button>
                        </div>
                        <div className="col-4 mt-3">
                            <button className='w-100 btn btn-secondary text-small-2'
                                    onClick={() => setHaveLocation(false)}

                            >
                                اصلاح موقعیت
                            </button>
                        </div>
                    </div>
                </section>
            }
            <section className="container  mt-1 py-4 rtl px-0  ">
                <div className="row ">

                    <div className="col-12 max-w-lg">


                        <MapContainer
                            center={center}
                            zoom={zoom}
                            scrollWheelZoom={true}
                            className='max-w-lg'
                            ref={setMap}

                        >
                            <TileLayer
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            <Marker
                                position={[position.lat.toFixed(4), position.lng.toFixed(4)]}
                            >
                                <Popup>
                                    A pretty CSS3 popup. <br/> Easily customizable.
                                </Popup>
                            </Marker>
                        </MapContainer>


                    </div>
                </div>
                <div className="row">
                    <div className="col-12 p-2 fixed-bottom max-w-lg">
                        {
                            !haveLocation &&
                            <button
                                className="btn btn-primary text-center text-small-1 text-semi-big  w-100 p-2  pr-4 border-0"
                                onClick={onSetLocation}
                            >
                                تایید موقعیت روی نقشه
                                <span className="badge  p-2 float-start">
<TbCheck className='text-big-3'/>
                    </span>
                            </button>}
                    </div>
                </div>
            </section>


        </React.Fragment>
    );
}

export default AddAddress;